import React, { useEffect } from "react";
import { useQuery } from "@apollo/client";
import { useHistory } from "react-router-dom";
import { UNLOCKED_COURSES_QUERY, CATEGORIES_WITH_PREVIEW_QUERY } from "../../queries/queries";
import PreviewCard from "./preview-card";
import Error from "../error";
import Loading from "../loading";
import useMakeScrollable from "../../custom_hooks/make-scrollable";
import CourseFind from './course-find';

const Courses = ({ }) => {
  const { loading, error, data } = useQuery(UNLOCKED_COURSES_QUERY, {
    fetchPolicy: "no-cache",
  });

  const preview = useQuery(CATEGORIES_WITH_PREVIEW_QUERY, {
    fetchPolicy: "no-cache",
  });


  useMakeScrollable()
  let history = useHistory();

  useEffect(() => {
    const wrapper = document.querySelector(".scrollable");
    if (!wrapper) return;
  });

  const handleAllClick = (categoryId) => {
    history.push({
      pathname: `/category_courses/${categoryId}`,
      state: { categoryId: categoryId }
    });
  };
  
  if (loading) return <Loading />;
  if (error) return <Error />;
  const categoriesWithCourses = preview.data.categoriesWithCourses

  const coursePreviews = categoriesWithCourses.map((category, index) => (
    <React.Fragment key={`${category.id}-${category.name}`}>
      {index > 0 && <div className="category-divider"></div>}
      <div className="category-section">
        <div className="new-courses-top">
          <div className="category-name">{category.name}</div>
          <div 
            className="new-courses-top-links" 
            onClick={() => handleAllClick(category.id)}
          >
            Alle
          </div>
        </div>
        <div className="courses-row">
          {category.previewCourses.map(course => (
            <div 
              className="course-item-container" 
              key={course.id}
              onClick={(e) => {
                e.preventDefault();
                history.push(`/course_details/${course.id}`);
              }}
            >
              <img className="course-item" src={course.previewUrl} />
              <div 
                className="course-item-title"
                dangerouslySetInnerHTML={{ __html: course.nameShort }}
              ></div>
            </div>
          ))}
        </div>
      </div>
    </React.Fragment>
  ));
  
  return (
    <div className="scrollable">
      <div className="courses-page">
        <CourseFind text={'Wissensbereich'}/>
        {coursePreviews}
      </div>
    </div>
  );
};

export default Courses;
